import { Input, message, notification } from "antd";
import React, { useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
const { Search } = Input;
import { useLoader } from "../../../context/LoaderContext";
import PropTypes from "prop-types";
import { MailCheck } from "lucide-react";
import {
  checkDirectorEmail,
  getTrainerWithCin,
} from "./CreateEpfComponents/surveyTriggers";
import GlobalContext from "../../../context/GlobalContext";
const SearchInputComponent = ({
  question,
  apiCall,
  maxLength,
  regex,
  message,
}) => {
  const { t } = useTranslation();
  const { showingPreview, setIsLoading, getSurveyData, setSurveyData } =
    useLoader();
  const { gouvernoratList } = useContext(GlobalContext);

  const expressionsMap = {
    trainer_data_cin_number: {
      apiCall: (survey) => getTrainerWithCin(survey, gouvernoratList, t),
      maxLength: 8,
      regex: /^\d{8}$/,
      message: t("Le numéro cin doit être au format 8 chiffres(ex: 11111111)."),
    },
    trainer_data_passport: {
      apiCall: (survey) => getTrainerWithCin(survey, gouvernoratList, t),
    },
    establishment_director_data_email: {
      apiCall: (survey) =>
        checkDirectorEmail(
          survey,
          setIsLoading,
          getSurveyData,
          setSurveyData,
          t,
          "edit"
        ),
      regex: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      message: t("Merci d'entrer une adresse mail valide."),
    },
  };

  const onClick = () => {
    if (expressionsMap[question.name]) {
      let expression = expressionsMap[question.name];
      let _survey = question.survey;
      if (expression && expression.apiCall) {
        return expression.apiCall(_survey);
      }
    } else {
      return apiCall();
    }
  };
  const searchFunction = (value) => {
    const regexExp = expressionsMap[question.name]
      ? expressionsMap[question.name].regex
      : regex;
    const messageExp = expressionsMap[question.name]
      ? expressionsMap[question.name].message
      : message;
    if (!value || value.trim() === "") {
      notification.error({
        message: t("Erreur"),
        description: t(
          `Veuillez remplir le champ avant de lancer la recherche`
        ),
        duration: 0,
      });
      return;
    }
    if (regexExp && !regexExp.test(value)) {
      notification.error({
        message: t("Erreur"),
        description: messageExp,
        duration: 0,
      });
      return;
    }
    onClick();
  };

  useEffect(() => {
    question.showRefreshBar = (isVisible) => {
      const searchInput = document?.querySelector(
        `div[data-name="${question?.name}"]`
      );
      if (searchInput) {
        searchInput.style.display = "block";
      }
    };
    return () => {
      delete question.showRefreshBar;
    };
  }, [question]);

  const onChange = (e) => {
    if (e) {
      question.value = e.target.value;
    } else {
      question.value = null;
    }
  };
  return (
    <Search
      enterButton={
        question.name === "establishment_director_data_email" ? (
          <MailCheck />
        ) : (
          true
        )
      }
      value={question.value ? question.value : null}
      onSearch={searchFunction}
      onChange={onChange}
      maxLength={
        expressionsMap[question.name]
          ? expressionsMap[question.name].maxLength
          : maxLength
      }
      disabled={
        question.readOnly ||
        sessionStorage.getItem("consulter") === "true" ||
        showingPreview
      }
      style={{ backgroundColor: "white" }}
    />
  );
};

SearchInputComponent.propTypes = {
  question: PropTypes.object,
  apiCall: PropTypes.func,
  maxLength: PropTypes.number,
  regex: PropTypes.object,
  message: PropTypes.message,
  gouvernoratList: PropTypes.array,
};
export default SearchInputComponent;
